var map = {
	"./07_icon_film.gif": 680,
	"./08_icon_data.gif": 681,
	"./09_icon_clients.gif": 682,
	"./10_icon_award.gif": 683,
	"./11_icon_time.gif": 684,
	"./12_icon_coffee.gif": 685
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 919;


//////////////////
// WEBPACK FOOTER
// ./public/img/counter-icons ^\.\/.*$
// module id = 919
// module chunks = 0